import { getFetchWrapper } from '@syf-api-library/core';
import ENDPOINTS from '../../const/endpoints';
const queryFnFactory = (config, keyProps, headers = {}) => {
    const fetchWrapper = getFetchWrapper(config);
    return () => {
        const params = new URLSearchParams({
            'cipher.accountId': keyProps.accountId
        });
        if (keyProps.accountIdType) {
            params.set('accountIdType', keyProps.accountIdType);
        }
        if (keyProps.interstitialSkipDate) {
            params.set('interstitialSkipDate', keyProps.interstitialSkipDate);
        }
        return fetchWrapper(`${ENDPOINTS.debtCancellation}?${params}`, {
            method: 'GET',
            headers: {
                ...headers
            }
        });
    };
};
export default queryFnFactory;
